export var DROPDOWN_TRIGGER = {
  CLICK: 'click',
  HOVER: 'hover',
  CONTEXT_MENU: 'contextMenu'
};
export var DROPDOWN_PLACEMENT = {
  BOTTOM_LEFT: 'bottomLeft',
  BOTTOM_CENTER: 'bottomCenter',
  BOTTOM_RIGHT: 'bottomRight',
  TOP_LEFT: 'topLeft',
  TOP_CENTER: 'topCenter',
  TOP_RIGHT: 'topRight'
};